import { Route } from 'react-router-dom';
import type { ReactElement } from 'react';
import { OnboardingLauncherPage } from './pages/Launcher';
import { GuidePage, GuidesPage } from './pages/Guides';
import { CustomerChecklistPage } from './pages/CustomerChecklist';
import { TenantWizardPage } from './pages/TenantWizard';
import { InstallationWizardPage } from './pages/InstallationWizard';
import { ScimWizardPage } from './pages/ScimWizard';
import { StatisticsWizardPage } from './pages/StatisticsWizard';
import { BuddyWizardPage } from './pages/BuddyWizard';
import { PrintQueueWizardPage } from './pages/PrintQueueWizard';
import { AutomationWizardPage } from './pages/AutomationWizard';

/** Path → nav entry it belongs to → page; wizards wrap their own environment shell where they need one. */
const PAGES: [string, string, () => ReactElement][] = [
  ['/onboarding/customers', '/onboarding/customers', () => <CustomerChecklistPage />],
  ['/onboarding/tenant', '/onboarding/tenant', () => <TenantWizardPage />],
  ['/onboarding/installation', '/onboarding/installation', () => <InstallationWizardPage />],
  ['/onboarding/scim', '/onboarding/scim', () => <ScimWizardPage />],
  ['/onboarding/statistics', '/onboarding/statistics', () => <StatisticsWizardPage />],
  ['/onboarding/buddy', '/onboarding/buddy', () => <BuddyWizardPage />],
  ['/onboarding/printqueue', '/onboarding/printqueue', () => <PrintQueueWizardPage />],
  ['/onboarding/automation', '/onboarding/automation', () => <AutomationWizardPage />],
];

/**
 * The Onboarding group's routes: the launcher and the installation guides when the group may be opened (the guides
 * have no nav entry of their own: the launcher and the wizards link to them), each wizard when its nav entry may be.
 */
export function onboardingRoutes(canOpenGroup: boolean, allowed: (path: string) => boolean) {
  return [
    canOpenGroup && <Route key="/onboarding" path="/onboarding" element={<OnboardingLauncherPage />} />,
    canOpenGroup && <Route key="/onboarding/guides" path="/onboarding/guides" element={<GuidesPage />} />,
    canOpenGroup && (
      <Route key="/onboarding/guides/:id" path="/onboarding/guides/:id" element={<GuidePage />} />
    ),
    ...PAGES.filter(([, nav]) => allowed(nav)).map(([path, , page]) => (
      <Route key={path} path={path} element={page()} />
    )),
  ];
}
